var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('az-call-to-action',{staticClass:"text-uppercase",attrs:{"active":""},on:{"click":function($event){return _vm.$emit('enviarParaHomologacao')}}},[_vm._v(" "+_vm._s(_vm.textoBotao)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }